(function () {
const MEGA_MENU_PANEL_CLASS = 'mega-menu-hover-open';
const MEGA_MENU_OPEN_CLASS = 'mega-menu-open';
const MEGA_MENU_CLOSE_DELAY = 150;

const coarsePointer = window.matchMedia('(hover: none)');

let lockedScrollPosition = 0;

function lockPageScroll() {
  if (document.body.classList.contains(MEGA_MENU_OPEN_CLASS)) return;

  lockedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  document.body.style.top = `-${lockedScrollPosition}px`;
  document.body.classList.add(MEGA_MENU_OPEN_CLASS);
}

function unlockPageScroll() {
  if (!document.body.classList.contains(MEGA_MENU_OPEN_CLASS)) return;

  document.body.classList.remove(MEGA_MENU_OPEN_CLASS);
  document.body.style.top = '';
  window.scrollTo(0, lockedScrollPosition);
}

/**
 * A <details> element does not render its content while closed, so opening it and
 * revealing the panel in the same task gives the browser no start value to
 * transition from. Committing the closed state first makes the open transition
 * replay on every open rather than only the first.
 */
function primeMegaMenuTransition(menu) {
  const wrapper = menu.querySelector('.mega-menu__wrapper');
  const content = menu.querySelector('.mega-menu__content');

  if (wrapper) {
    wrapper.style.animation = 'none';
    void wrapper.offsetHeight;
    wrapper.style.animation = '';
  }

  if (content) {
    content.style.transition = 'none';
    content.style.height = '0px';
    void content.offsetHeight;
    content.style.transition = '';
    content.style.height = '';
  }
}

function showMegaMenuPanel(menu, trigger) {
  if (menu.classList.contains(MEGA_MENU_PANEL_CLASS)) return;

  primeMegaMenuTransition(menu);
  menu.classList.add(MEGA_MENU_PANEL_CLASS);
  trigger.setAttribute('aria-expanded', 'true');
}

function hideMegaMenuPanel(menu, trigger) {
  if (!menu.classList.contains(MEGA_MENU_PANEL_CLASS)) return;

  menu.classList.remove(MEGA_MENU_PANEL_CLASS);
  trigger.setAttribute('aria-expanded', 'false');
}

function initMegamenuAnimation() {
  document.querySelectorAll('.mega-menu').forEach((menu) => {
    const trigger = menu.querySelector('.mega-menu__trigger');
    if (!trigger) return;

    let closeTimeout = null;

    const cancelClose = () => {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    };

    const scheduleClose = () => {
      cancelClose();
      closeTimeout = setTimeout(() => {
        closeTimeout = null;
        menu.removeAttribute('open');
        hideMegaMenuPanel(menu, trigger);
      }, MEGA_MENU_CLOSE_DELAY);
    };

    /**
     * Keep scroll lock + CSS class in sync when <details> opens via keyboard
     * (Enter/Space). Mouse clicks use detail &gt; 0 and stay hover-driven below.
     */
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        lockPageScroll();
        showMegaMenuPanel(menu, trigger);
      } else {
        hideMegaMenuPanel(menu, trigger);
        requestAnimationFrame(() => {
          if (!document.querySelector('details.mega-menu[open]')) {
            unlockPageScroll();
          }
        });
      }
    });
    
    trigger.addEventListener('click', (e) => {
      // Keyboard / AT activation uses a synthetic click with detail 0; allow native
      // <details> toggle so users can open the panel with Enter or Space.
      if (e.detail === 0 || coarsePointer.matches) return;
      e.preventDefault();
      e.stopPropagation();
    });

    menu.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !menu.open) return;
      e.preventDefault();
      menu.removeAttribute('open');
      trigger.focus();
    });
    
    trigger.addEventListener('mouseenter', () => {
      if (coarsePointer.matches) return;

      cancelClose();
      lockPageScroll();
      menu.setAttribute('open', '');
      showMegaMenuPanel(menu, trigger);
    });

    menu.addEventListener('mouseenter', cancelClose);
    menu.addEventListener('mouseleave', scheduleClose);
  });
}

/**
 * Megamenu Overlay Image Functionality
 * Handles showing/hiding overlay images when hovering over submenu items
 */

function initMegamenuOverlays() {
  const submenuLinks = document.querySelectorAll('[data-submenu-item]');
  const overlayImages = document.querySelectorAll('[data-overlay-for]');
  
  if (submenuLinks.length === 0 || overlayImages.length === 0) return;
  
  // Initialize all overlays to be rendered but invisible
  // This ensures transitions work smoothly
  overlayImages.forEach(overlay => {
    overlay.style.display = 'flex';
  });
  
  let hideTimeout;
  
  function showOverlay(submenuItem) {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
    overlayImages.forEach(overlay => {
      const isTarget = overlay.getAttribute('data-overlay-for') === submenuItem;

      if (isTarget) {
        // Show the target overlay with a fade-in
        overlay.style.display = 'flex';
        overlay.classList.remove('fade-out');
        
        // Not the prettiest solution but double RAF ensures display is applied before transition starts
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            overlay.classList.add('active');
          });
        });
      } else {
        // Hide other overlays - fade out if currently active
        if (overlay.classList.contains('active')) {
          overlay.classList.remove('active');
          overlay.classList.add('fade-out');
        }
      }
    });
  }
  
  function hideOverlays() {
    overlayImages.forEach(overlay => {
      if (overlay.classList.contains('active')) {
        overlay.classList.remove('active');
        overlay.classList.add('fade-out');
      }
    });
  }
  
  submenuLinks.forEach(link => {
    const oldEnterListener = link._overlayEnterListener;
    const oldLeaveListener = link._overlayLeaveListener;
    
    if (oldEnterListener) {
      link.removeEventListener('mouseenter', oldEnterListener);
    }
    if (oldLeaveListener) {
      link.removeEventListener('mouseleave', oldLeaveListener);
    }
    
    // Create new listeners for mouseenter and mouseleave events
    const newEnterListener = function() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
      const submenuItem = this.getAttribute('data-submenu-item');
      showOverlay(submenuItem);
    };
    
    const newLeaveListener = function(e) {
      if (hideTimeout) clearTimeout(hideTimeout);
      
      // Check if we're moving to another submenu link
      const relatedTarget = e.relatedTarget;
      const isMovingToSubmenuLink = relatedTarget && (
        relatedTarget.hasAttribute('data-submenu-item') ||
        relatedTarget.closest('[data-submenu-item]')
      );
      
      // If moving to another submenu link, don't hide so we can show the new overlay
      if (isMovingToSubmenuLink) {
        return;
      }
      
      // Otherwise hide the overlay after a short delay
      hideTimeout = setTimeout(() => {
        hideOverlays();
        hideTimeout = null;
      }, 100);
    };
    
    link._overlayEnterListener = newEnterListener;
    link._overlayLeaveListener = newLeaveListener;
    
    link.addEventListener('mouseenter', newEnterListener);
    link.addEventListener('mouseleave', newLeaveListener);
  });
  
  const megaMenus = document.querySelectorAll('.mega-menu__wrapper');
  megaMenus.forEach(menu => {
    const oldListener = menu._hideOverlaysListener;
    if (oldListener) {
      menu.removeEventListener('mouseleave', oldListener);
    }
    
    const newListener = function() {
      hideOverlays();
    };
    
    menu._hideOverlaysListener = newListener;
    menu.addEventListener('mouseleave', newListener);
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  initMegamenuAnimation();
  initMegamenuOverlays();
});

// Re-initialize when theme editor updates sections/blocks
document.addEventListener('shopify:section:load', () => {
  initMegamenuAnimation();
  initMegamenuOverlays();
});
document.addEventListener('shopify:section:reorder', () => {
  initMegamenuAnimation();
  initMegamenuOverlays();
});
document.addEventListener('shopify:block:select', () => {
  initMegamenuAnimation();
  initMegamenuOverlays();
});
})();
